import React from 'react';

import { AdvertFragment } from '@Graphql/graphqlTypes.generated';
import { useCurrency } from '@Hooks/useCurrency';
import PlaceholderImage from '@Images/placeholder.png';
import { convertCentsToMoney } from '@Utils/money';
import { buildFullAdvertUrl } from '@Utils/url';

export interface ProductSchemaProps {
  advert: AdvertFragment;
}

const structuredData = ({ advert, currency }: ProductSchemaProps & { currency: string }) => {
  const { title, mainImage } = advert;

  const advertImageUrl = mainImage || PlaceholderImage;

  return JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'Product',
    description: advert.description,
    image: advertImageUrl,
    url: buildFullAdvertUrl(advert),
    name: title,
    offers: getVariantsStructuredData(advert, currency),
  });
};

const getVariantsStructuredData = (advert: AdvertFragment, currency: string) => {
  const { price, company } = advert;

  const inStock = 'https://schema.org/InStock';

  return {
    '@type': 'Offer',
    price: convertCentsToMoney(price),
    availability: inStock,
    priceCurrency: currency,
    url: buildFullAdvertUrl(advert),
    seller: {
      '@type': 'Organization',
      name: company.name,
    },
  };
};

const AdvertSchema: React.FC<ProductSchemaProps> = ({ advert }) => {
  const currency = useCurrency();
  return <script type="application/ld+json">{structuredData({ advert, currency })}</script>;
};

export default AdvertSchema;
